import PropTypes from 'prop-types';

const reservationShape = PropTypes.shape({
  attendee: PropTypes.shape({
    token: PropTypes.string,
    type: PropTypes.string,
  }),
  cancellationPolicy: PropTypes.arrayOf(
    PropTypes.string
  ),
  conciergeResyToken: PropTypes.oneOfType([PropTypes.string, () => null]),
  config: PropTypes.shape({
    type: PropTypes.string,
  }),
  day: PropTypes.string,
  id: PropTypes.number.isRequired,
  pastOrFuture: PropTypes.string,
  payment: PropTypes.shape({
    items: PropTypes.arrayOf(
      PropTypes.shape({
        amount: PropTypes.number,
        name: PropTypes.string,
        quantity: PropTypes.number,
      })
    ),
    resy_fee_amount: PropTypes.number,
    service_charge_amount: PropTypes.number,
    tax_amount: PropTypes.number,
  }),
  price: PropTypes.number,
  seats: PropTypes.number,
  share: PropTypes.shape({
    generic_message: PropTypes.string,
    link: PropTypes.string,
  }),
  tableType: PropTypes.string,
  token: PropTypes.string.isRequired,
  time: PropTypes.string,
  venue: PropTypes.shape({
    contact: PropTypes.shape({
      phone: PropTypes.shape({
        phoneLabel: PropTypes.string,
        phoneUrl: PropTypes.string,
      }),
      url: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({ phone_number: PropTypes.string }),
      ]),
    }),
    location: PropTypes.shape({
      address1: PropTypes.string,
      city: PropTypes.string,
      postalCode: PropTypes.string,
      state: PropTypes.string,
    }),
    isResyCreditEligible: PropTypes.bool,
    name: PropTypes.string,
    taxIncluded: PropTypes.bool,
  }),
});

export default reservationShape;
